module.exports = __webpack_public_path__ + "img/co-funded.7df2643d.png";